module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._v("\n  Spirit of Metal © 2003 - " + _vm._s(new Date().getFullYear()) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f4c8f81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footer.vue
// module id = 255
// module chunks = 0